import 'rangeslider.js';
import 'flatpickr';
import 'autosize';
import './base/index';
import './dashboard/reactEmbed';
import initBulkActions from './dashboard/bulkactions';
import dialcode from './dashboard/dialcode';
import initDropdown from './dashboard/dropdown';
import showAccessCode from './dashboard/examAccessCode/exam-access-code';
import formAnchorRestore from './dashboard/form-anchor-restore';
import formPjaxSubmit from './dashboard/form-pjax-submit';
import initForm from './dashboard/form/index';
import initGridViewFilter from './dashboard/grid-view-filter';
import initGridViewLoader from './dashboard/grid-view-loader';
import initGridViewSelectSorter from './dashboard/grid-view-select-sorter';
import learningContentModal from './dashboard/learning-content-modal';

import initNavigationDropdown from './dashboard/navigation-dropdown';
import offCanvas from './dashboard/off-canvas';
import pjaxButton from './dashboard/pjax-button';
import initPjaxCloseModal from './dashboard/pjax-close-modal';
import pjaxRefresh from './dashboard/pjax-refresh';
import pjaxTrigger from './dashboard/pjax-trigger';
import pjaxUpdate from './dashboard/pjax-update';
import initQuestionsMultipleCorrectAnswers from './dashboard/questions-multiple-correct-answers';
import replace from './dashboard/replace';
import revealModal from './dashboard/reveal-modal';
import initSelectText from './dashboard/select-text';
import initShowIf from './dashboard/show-if';
import showImportResultButton from './dashboard/showImportResultButton.js';
import initSortableGridView from './dashboard/sortable-grid-view';
import initTabLoader from './dashboard/tab-loader';
import update from './dashboard/update';
import updateAttributes from './dashboard/update-attributes';

initShowIf();
pjaxButton();
initNavigationDropdown();
initSortableGridView();
initQuestionsMultipleCorrectAnswers();
initGridViewLoader();
replace();
offCanvas();
initBulkActions();
initSelectText();
formPjaxSubmit();
pjaxRefresh();
pjaxUpdate();
initPjaxCloseModal();
initForm();
revealModal();
initDropdown();
learningContentModal();
dialcode();
updateAttributes();
update();
initTabLoader();
pjaxTrigger();
showAccessCode();
showImportResultButton();
formAnchorRestore();
initGridViewFilter();
initGridViewSelectSorter();
